import axios from 'axios';
import { message } from 'antd';

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: 'https://api.coinsup.in/api/v1' || 'http://localhost:5000/api', // Adjust base URL as needed
  timeout: 30000, // 30 seconds timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common error responses
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 401:
          // Unauthorized - clear token and redirect to login
          localStorage.removeItem('token');
          message.error('Session expired. Please login again.');
          // You might want to redirect to login page here
          // window.location.href = '/login';
          break;
          
        case 403:
          message.error('Access forbidden');
          break;
          
        case 404:
          message.error('Resource not found');
          break;
          
        case 422:
          // Validation errors
          if (data.errors && Array.isArray(data.errors)) {
            data.errors.forEach(err => message.error(err.message || err));
          } else {
            message.error(data.message || 'Validation failed');
          }
          break;
          
        case 500:
          message.error('Server error. Please try again later.');
          break;
          
        default:
          message.error(data.message || 'Something went wrong');
      }
    } else if (error.request) {
      // Network error
      message.error('Network error. Please check your connection.');
    } else {
      message.error('Request failed. Please try again.');
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;